module.exports = __webpack_public_path__ + "static/media/small-game@3x.0e0c5bdb.jpg";